import Instrument from '../Instrument.js';
import {mate} from 'genetix/Flip.js';
import {A_RATE} from 'constants/automation-rates.js';
import {sleep} from 'utils/sleep.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AbstractParameter,
        IntegerParameter} from 'parameters/AbstractParameter.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {MULTI_SYNTH} from 'constants/instrument-types.js';
import SynthEnvelope from '../SynthEnvelope.js';
import FilterEnvelope from '../FilterEnvelope.js';
import Effects from 'effects/Effects.js';
import LFO from 'modulators/LFO.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';
import {AMP, PITCH, FILTER} from 'constants/envelope-types.js';

const PORTAMENTO_FACTOR = 20.0;

class MultiOscillatorSynth extends Instrument {
    constructor(sequencerEngine, mixSession, context, connectAudioNodes=true) {
        super();

        // state objects (mainly for registering parameters)
        this.sequencerEngine = sequencerEngine;
        this.store = sequencerEngine.store;
        this.mixSession = mixSession;
        this.context = context.getCopy().forInstrument(this);

        // keeps track whether we've set the polyphony parameter

        // keeps track of all parameters of the synth
        this.parameters = [];
    }

    // connects the synth to the given audio node (i.e. the mix)
    getName() {
        return 'Synth';
    }

    get name() {
        return this.getName();
    }

    getInstrument() {
        return this;
    }

    getInstrumentType() {
        return MULTI_SYNTH;
    }
    createLFO() {
        return new LFO(this.sequencerEngine, this.mixSession, this.context);
    }

    getCopy(context, sequencerEngine=this.sequencerEngine) {
        let synth = new MultiOscillatorSynth(sequencerEngine, this.mixSession, context);
        synth.fromJsonSync(this.getJson());
        return synth;
    }


    mateJson(partner, probability=0.5) {
        // oscillatoors
        for (let i in partner.oscillators) {
            let oscillator = this.getOscillator(i);
            oscillator.mateJson(partner.oscillators[i]);
        }

        this.ampEnvelope.mateJson(partner.ampEnvelope, probability);
        this.filterEnvelope.mateJson(partner.filterEnvelope, probability);
        this.pitchEnvelope.mateJson(partner.pitchEnvelope, probability);
        this.mateParameter('filterCutoff', partner, this.filterCutoffParameter, probability);
        this.mateParameter('filterQ', partner, this.filterQParameter, probability);
        this.mateParameter('noiseVolume', partner, this.noiseVolumeParameter, probability);
    }

    mateParameter(name, data, param1, probability) {
        mate(this.sequencerEngine, name, data, param1, probability);
    }

    dispose() {
        let nodes = [... this.oscillatorNodes];
        nodes.reverse();
        nodes.forEach(
            osc => osc.dispose());

        this.filter.dispose();
        this.hpFilter.dispose();
        this.pitchEnvelope.dispose();
        this.filterEnvelope.dispose();
        this.hpFilterEnvelope.dispose();
        this.ampEnvelope.dispose();

        this.oscillatorNodes = undefined;
        this.filter = undefined;
        this.hpFilter = undefined;
        this.pitchEnvelope = undefined;
        this.filterEnvelope = undefined;
        this.ampEnvelope = undefined;

        this.parameters.forEach(s => s.dispose());
        this.parameters = undefined;
        this._disposed = true;
    }

    get disposed() {
        return this._disposed;
    }
}


export default MultiOscillatorSynth;
